/** @jsxImportSource @emotion/react */

import { useState } from "react";
import { FindFormContainer, InputForm, PwEyeIconTouchPoint, TitleSection } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { css } from "@emotion/react";

const validatePasswordMatch = (pw?: string, comparePW?: string) => {
  if (pw === comparePW) return true;
  else return false;
};

export const validatePasswordFormat = (password: string) => {
  if (password.length < 8) {
    return false;
  }

  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return hasLetter && hasNumber && hasSpecialChar;
};

const RePassword = ({ onClickComplete }: { onClickComplete: (password?: string) => void }) => {
  const [showNewPw, setShowNewPw] = useState<boolean>(false);
  const [showRePw, setShowRePw] = useState<boolean>(false);
  const [newPw, setNewPw] = useState<string>();
  const [rePw, setRePw] = useState<string>();

  return (
    <>
      <FindFormContainer>
        <TitleSection>
          <UI.Typography type="title01" fontStyle="bold" color="var(--alias-color-label-normal)">
            비밀번호 재설정
          </UI.Typography>
          <UI.Typography type="heading02" fontStyle="medium" color="var(--alias-color-label-alternative)">
            새로운 비밀번호를 설정해주세요.
          </UI.Typography>
        </TitleSection>
        <InputForm>
          <div
            css={css`
              position: relative;
            `}
          >
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
              비밀번호
            </UI.Typography>
            <UI.Input
              error={newPw ? !validatePasswordFormat(newPw) : false}
              showHelpText={true}
              helpText="최소 8자 이상, 영문/숫자/특수문자의 조합으로 설정해 주세요."
              placeholder="새 비밀번호"
              size="medium"
              style={{ marginTop: "4px" }}
              showSuffixIcon
              suffixIcon={showNewPw ? "eyeClosed" : "eye"}
              onChange={(value) => value.length <= 16 && setNewPw(value)}
              type={showNewPw ? "text" : "password"}
              value={newPw}
            />
            <PwEyeIconTouchPoint onClick={() => setShowNewPw(!showNewPw)}></PwEyeIconTouchPoint>
          </div>
          <div
            css={css`
              position: relative;
            `}
          >
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
              새 비밀번호 확인
            </UI.Typography>
            <UI.Input
              showHelpText={rePw ? !validatePasswordMatch(newPw, rePw) : false}
              error={rePw ? !validatePasswordMatch(newPw, rePw) : false}
              helpText="비밀번호가 일치하지 않습니다."
              placeholder="새 비밀번호"
              size="medium"
              style={{ marginTop: "4px" }}
              showSuffixIcon
              suffixIcon={showRePw ? "eyeClosed" : "eye"}
              onChange={(value) => value.length <= 16 && setRePw(value)}
              type={showRePw ? "text" : "password"}
              value={rePw}
            />
            <PwEyeIconTouchPoint onClick={() => setShowRePw(!showRePw)}></PwEyeIconTouchPoint>
          </div>
        </InputForm>
        <UI.Button
          onClick={
            validatePasswordMatch(newPw, rePw) && validatePasswordFormat(newPw ?? "")
              ? () => onClickComplete(newPw)
              : () => {}
          }
          size="large"
          title="비밀번호 재설정"
          disabled={rePw ? !(validatePasswordMatch(newPw, rePw) && validatePasswordFormat(newPw ?? "")) : true}
          style={{ width: "100%" }}
        />
      </FindFormContainer>
    </>
  );
};

export default RePassword;
